import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    userFilters: null,
    warehouses: [],
    zones: [],
}

export const filtersSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        setUserFilters: (state, action) => {
            state.userFilters = action.payload
        },
        setFilterWarehouses: (state, action) => {
            state.warehouses = action.payload
        },
        setFilterZones: (state, action) => {
            state.zones = action.payload
        },
        setProcessedFilters: (state, action) => {
            const { warehouses, zones } = action.payload
            state.warehouses = warehouses || []
            state.zones = zones || []
        },
        clearFilters: (state) => {
            state.userFilters = null
            state.warehouses = []
            state.zones = []
        },
    },
})

export const { 
    setUserFilters, 
    setFilterWarehouses, 
    setFilterZones, 
    setProcessedFilters,
    clearFilters 
} = filtersSlice.actions

export default filtersSlice.reducer

